(function () {
  var endpoint = window.BIOTRACE_N8N_ENDPOINT || '';
  if (!endpoint) return;

  var boundKey = '__biotraceN8NBound';

  function formatDateTime() {
    var now = new Date();
    return now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + ' ' +
      String(now.getHours()).padStart(2, '0') + ':' +
      String(now.getMinutes()).padStart(2, '0') + ':' +
      String(now.getSeconds()).padStart(2, '0');
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
  }

  function getFieldValue(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var field = form.querySelector(selectors[i]);
      if (!field) continue;
      var value = '';
      if (field.type === 'checkbox') {
        value = field.checked ? field.value : '';
      } else {
        value = (field.value || '').trim();
      }
      if (value) return value;
    }
    return '';
  }

  function getFirstHeadingText() {
    var heading = document.querySelector('main h1, .main-content h1, .page-inner h1');
    return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function ensureMessageNode(form) {
    var node = form.querySelector('.n8n-form-message');
    if (!node) {
      node = document.createElement('div');
      node.className = 'n8n-form-message';
      node.style.marginTop = '12px';
      node.style.fontSize = '14px';
      form.appendChild(node);
    }
    return node;
  }

  function showMessage(form, message, type) {
    var node = ensureMessageNode(form);
    node.textContent = message;
    node.style.display = 'block';
    node.style.color = type === 'success' ? '#1f8f4d' : '#d03b3b';
  }

  function clearMessage(form) {
    var node = form.querySelector('.n8n-form-message');
    if (node) {
      node.textContent = '';
      node.style.display = 'none';
    }
  }

  function setButtonBusy(button, loadingText) {
    if (!button) return function () {};
    var originalHtml = button.innerHTML;
    var originalDisabled = button.disabled;
    button.disabled = true;
    button.style.opacity = '0.7';
    button.style.cursor = 'not-allowed';
    button.innerHTML = loadingText;
    return function restore() {
      button.disabled = originalDisabled;
      button.style.opacity = '';
      button.style.cursor = '';
      button.innerHTML = originalHtml;
    };
  }

  function postJson(payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Request failed with status ' + response.status);
      }
      return response.text().then(function (text) {
        if (!text) return {};
        try {
          return JSON.parse(text);
        } catch (error) {
          return { success: true, message: text };
        }
      });
    });
  }

  function postFormData(formData) {
    return fetch(endpoint, {
      method: 'POST',
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Request failed with status ' + response.status);
      }
      return response.text().then(function (text) {
        if (!text) return {};
        try {
          return JSON.parse(text);
        } catch (error) {
          return { success: true, message: text };
        }
      });
    });
  }

  function buildContactMessage(title, fields) {
    var lines = [
      title,
      '',
      'Name: ' + (fields.name || ''),
      'Email: ' + (fields.email || '')
    ];

    if (fields.phone) lines.push('Phone: ' + fields.phone);
    if (fields.organization) lines.push('Organization: ' + fields.organization);
    if (fields.inquiryType) lines.push('Inquiry Type: ' + fields.inquiryType);
    if (fields.service) lines.push('Service: ' + fields.service);
    if (fields.product) lines.push('Product: ' + fields.product);
    if (fields.productUrl) lines.push('Product URL: ' + fields.productUrl);
    lines.push('Date: ' + fields.date);
    lines.push('');
    lines.push('Message:');
    lines.push(fields.message || '');

    return lines.join('\n').trim();
  }

  function bindNewsletterForm(form) {
    if (form[boundKey]) return;
    form[boundKey] = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage(form);

      var email = getFieldValue(form, [
        'input[name="contact[email]"]',
        'input[type="email"]'
      ]);

      if (!isValidEmail(email)) {
        showMessage(form, 'Please enter a valid email address.', 'error');
        return;
      }

      var button = form.querySelector('button[type="submit"], input[type="submit"]');
      var restore = setButtonBusy(button, '<span>Submitting...</span>');

      postJson({
        email: email,
        subject: 'New Newsletter Subscription',
        message: 'New newsletter subscription from: ' + email,
        date: formatDateTime(),
        form_type: 'Newsletter Subscription'
      }).then(function () {
        form.reset();
        showMessage(form, 'Thank you for subscribing to our newsletter!', 'success');
      }).catch(function () {
        showMessage(form, 'An error occurred. Please try again later.', 'error');
      }).finally(function () {
        restore();
      });
    });
  }

  function bindQuoteForm(form) {
    if (form[boundKey]) return;
    form[boundKey] = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage(form);

      var name = getFieldValue(form, ['input[name="contact[name]"]']);
      var email = getFieldValue(form, ['input[name="contact[email]"]']);
      var phone = getFieldValue(form, ['input[name="contact[phone]"]']);
      var organization = getFieldValue(form, [
        'input[name="contact[company]"]',
        'input[name="contact[Organization]"]',
        'input[name="contact[organization]"]'
      ]);
      var service = getFieldValue(form, [
        'select[name="contact[service]"]',
        'select[name="contact[services]"]',
        'select[name="contact[Enquiry Type]"]'
      ]);
      var message = getFieldValue(form, ['textarea[name="contact[body]"]']);
      var date = formatDateTime();

      if (!name || !isValidEmail(email) || !message) {
        showMessage(form, 'Please fill in the required fields.', 'error');
        return;
      }

      var subject = 'New Quote Request from ' + name;
      if (organization) {
        subject += ' - ' + organization;
      }

      var fullMessage = [
        'New Quote Request Received',
        '',
        'Name: ' + name,
        'Email: ' + email,
        organization ? 'Organization: ' + organization : '',
        phone ? 'Phone: ' + phone : '',
        service ? 'Inquiry Type: ' + service : '',
        'Date: ' + date,
        '',
        'Message:',
        message
      ].filter(Boolean).join('\n');

      var button = form.querySelector('button[type="submit"], input[type="submit"]');
      var restore = setButtonBusy(button, '<span>Sending...</span>');

      postJson({
        email: email,
        subject: subject,
        message: fullMessage,
        date: date,
        customer_name: name,
        customer_email: email,
        customer_phone: phone,
        customer_organization: organization,
        inquiry_type: service,
        customer_message: message,
        form_type: 'Get Your Quote'
      }).then(function () {
        form.reset();
        showMessage(form, 'Thank you for your quote request! We will contact you shortly.', 'success');
      }).catch(function () {
        showMessage(form, 'Sorry, there was an error sending your request. Please try again later.', 'error');
      }).finally(function () {
        restore();
      });
    });
  }

  function bindContactForm(form, formType) {
    if (form[boundKey]) return;
    form[boundKey] = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage(form);

      var name = getFieldValue(form, ['input[name="contact[name]"]']);
      var email = getFieldValue(form, ['input[name="contact[email]"]']);
      var phone = getFieldValue(form, ['input[name="contact[phone]"]']);
      var organization = getFieldValue(form, [
        'input[name="contact[organization]"]',
        'input[name="contact[Organization]"]',
        'input[name="contact[company]"]'
      ]);
      var inquiryType = getFieldValue(form, [
        'select[name="contact[inquiry_type]"]',
        'select[name="contact[Enquiry Type]"]'
      ]);
      var service = getFieldValue(form, [
        'select[name="contact[services]"]',
        'select[name="contact[service]"]'
      ]);
      var message = getFieldValue(form, ['textarea[name="contact[body]"]']);
      var product = getFieldValue(form, ['input[name="contact[product]"]']);
      var productUrl = getFieldValue(form, ['input[name="contact[product url]"]']);
      var date = formatDateTime();

      if (!name || !isValidEmail(email) || !message) {
        showMessage(form, 'Please fill in the required fields.', 'error');
        return;
      }

      var subject = 'New ' + formType + ' from ' + name;
      var payload = {
        email: email,
        subject: subject,
        message: buildContactMessage('New ' + formType + ' Received', {
          name: name,
          email: email,
          phone: phone,
          organization: organization,
          inquiryType: inquiryType,
          service: service,
          message: message,
          product: product,
          productUrl: productUrl,
          date: date
        }),
        date: date,
        customer_name: name,
        customer_email: email,
        customer_phone: phone,
        customer_organization: organization,
        inquiry_type: inquiryType,
        service_type: service,
        customer_message: message,
        product: product,
        product_url: productUrl,
        form_type: formType
      };

      var button = form.querySelector('button[type="submit"], input[type="submit"]');
      var restore = setButtonBusy(button, '<span>Sending...</span>');

      postJson(payload).then(function () {
        form.reset();
        showMessage(form, 'Thank you for your message! We will get back to you soon.', 'success');
      }).catch(function () {
        showMessage(form, 'Something went wrong. Please try again later.', 'error');
      }).finally(function () {
        restore();
      });
    });
  }

  function inferTrainingProgram(form) {
    var modal = form.closest('#ipEnrollOverlay, [id^="enrollOverlay"], .ip-enroll-modal, [class*="enroll-modal-"]');
    if (modal) {
      var titleEl = modal.querySelector('h2, .e-header');
      if (titleEl) {
        return titleEl.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    var pageHeading = getFirstHeadingText();
    if (pageHeading) {
      return pageHeading + ' Enrollment';
    }

    return 'Training Enrollment';
  }

  function closeTrainingModal(form) {
    var overlay = form.closest('#ipEnrollOverlay, [id^="enrollOverlay"]');
    if (!overlay) return;

    if (overlay.id === 'ipEnrollOverlay') {
      overlay.classList.remove('active');
    } else {
      overlay.classList.remove('active');
      overlay.style.display = '';
    }
    document.body.style.overflow = '';
  }

  function bindTrainingForm(form) {
    if (form[boundKey]) return;
    form[boundKey] = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage(form);

      var name = getFieldValue(form, ['input[name="name"]']);
      var mobile = getFieldValue(form, ['input[name="mobile"]']);
      var email = getFieldValue(form, ['input[name="email"]']);
      var city = getFieldValue(form, ['input[name="city"]']);
      var college = getFieldValue(form, ['input[name="college"]']);
      var qualification = getFieldValue(form, ['input[name="qualification"]']);
      var duration = getFieldValue(form, ['input[name="duration"]']);
      var message = getFieldValue(form, ['textarea[name="message"]']);
      var programType = inferTrainingProgram(form);

      if (!name || !mobile || !isValidEmail(email) || !city || !college || !qualification || !duration) {
        showMessage(form, 'Please fill in the required fields.', 'error');
        return;
      }

      var button = form.querySelector('button[type="submit"]');
      var restore = setButtonBusy(button, '<span>Submitting...</span>');

      postJson({
        name: name,
        mobile: mobile,
        email: email,
        city: city,
        college: college,
        qualification: qualification,
        duration: duration,
        message: message,
        submitted_at: new Date().toISOString(),
        form_type: programType
      }).then(function () {
        form.reset();
        showMessage(form, 'Thank you for enrolling! We will contact you soon with further details.', 'success');
        setTimeout(function () {
          closeTrainingModal(form);
        }, 2000);
      }).catch(function () {
        showMessage(form, 'Sorry, there was an error submitting your enrollment. Please try again.', 'error');
      }).finally(function () {
        restore();
      });
    });
  }

  function resetCareerUploadUi() {
    var uploadBox = document.getElementById('jobUploadBox');
    var uploadIcon = document.getElementById('jobUploadIcon');
    var uploadTitle = document.getElementById('jobUploadTitle');
    var uploadHint = document.getElementById('jobUploadHint');
    var uploadFilename = document.getElementById('jobUploadFilename');
    var resumeInput = document.getElementById('jobResumeInput');

    if (resumeInput) resumeInput.value = '';
    if (uploadIcon) uploadIcon.className = 'fas fa-cloud-upload-alt';
    if (uploadTitle) uploadTitle.innerHTML = 'Choose file <span>or drag here</span>';
    if (uploadHint) uploadHint.style.display = '';
    if (uploadFilename) {
      uploadFilename.style.display = 'none';
      uploadFilename.textContent = '';
    }
    if (uploadBox) {
      uploadBox.style.borderColor = '';
      uploadBox.style.background = '';
    }
  }

  function bindCareerForm(form) {
    if (form[boundKey]) return;
    form[boundKey] = true;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage(form);

      var name = getFieldValue(form, ['input[name="name"]']);
      var email = getFieldValue(form, ['input[name="email"]']);
      var phone = getFieldValue(form, ['input[name="phone"]']);
      var education = getFieldValue(form, ['select[name="education"]']);
      var experience = getFieldValue(form, ['select[name="experience"]']);
      var resumeInput = form.querySelector('input[name="resume"]');
      var resumeFile = resumeInput && resumeInput.files ? resumeInput.files[0] : null;
      var popupTitle = document.getElementById('jobPopupTitle');
      var jobTitle = popupTitle ? popupTitle.textContent.replace(/^Apply for\s+/i, '').trim() : 'Position';
      var date = formatDateTime();

      if (!name || !isValidEmail(email) || !phone || !education || !resumeFile) {
        showMessage(form, 'Please complete all required fields and upload your resume.', 'error');
        return;
      }

      var formData = new FormData();
      formData.append('email', email);
      formData.append('subject', 'New Job Application: ' + jobTitle + ' - ' + name);
      formData.append('date', date);
      formData.append('applicant_name', name);
      formData.append('applicant_email', email);
      formData.append('applicant_phone', phone);
      formData.append('applicant_education', education);
      formData.append('applicant_experience', experience);
      formData.append('job_title', jobTitle);
      formData.append('job_location', 'Bhubaneswar');
      formData.append('resume_filename', resumeFile.name);
      formData.append('resume_type', resumeFile.type || 'application/octet-stream');
      formData.append('form_type', 'Job Application');
      formData.append('resume', resumeFile, resumeFile.name);

      var button = form.querySelector('button[type="submit"]');
      var restore = setButtonBusy(button, '<span>Submitting application...</span>');

      postFormData(formData).then(function () {
        form.reset();
        resetCareerUploadUi();
        showMessage(form, 'Application submitted successfully. We will review it and contact you soon.', 'success');
        setTimeout(function () {
          var popup = document.getElementById('jobApplicationPopup');
          if (popup) popup.style.display = 'none';
          document.body.style.overflow = '';
        }, 4000);
      }).catch(function () {
        showMessage(form, 'Sorry, there was an error submitting your application. Please try again later.', 'error');
      }).finally(function () {
        restore();
      });
    });
  }

  function detectAndBindForm(form) {
    if (!form || form[boundKey]) return;

    if (form.id === 'jobApplicationForm') {
      bindCareerForm(form);
      return;
    }

    if (form.classList.contains('n8n-training-form')) {
      bindTrainingForm(form);
      return;
    }

    if (form.classList.contains('n8n-newsletter-form') || form.querySelector('input[name="contact[tags]"][value="newsletter"]')) {
      bindNewsletterForm(form);
      return;
    }

    if (form.classList.contains('n8n-quote-form')) {
      bindQuoteForm(form);
      return;
    }

    if (form.classList.contains('n8n-contact-form')) {
      bindContactForm(form, 'Contact Us');
      return;
    }

    if (form.classList.contains('n8n-product-ask-form')) {
      bindContactForm(form, 'Product Inquiry');
      return;
    }

    if (form.classList.contains('n8n-faq-contact-form')) {
      bindContactForm(form, 'FAQ Contact');
    }
  }

  function scanForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i += 1) {
      detectAndBindForm(forms[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanForms();

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        scanForms();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
})();

// Reuse the product inquiry modal for COA requests.
(function () {
  var coaMessage = 'Requesting for COA';

  // Update the popup before Bootstrap opens it.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-target="#Shopask"]');
    if (!trigger) return;

    var modal = document.getElementById('Shopask');
    if (!modal) return;

    var form = modal.querySelector('.n8n-product-ask-form');
    var title = modal.querySelector('.Shopask-title');
    var message = modal.querySelector(
      'textarea[name="contact[body]"]'
    );
    var messageGroup = modal.querySelector('[data-inquiry-message]');

    if (!form || !title || !message || !messageGroup) return;

    // Remember the original title and any unfinished question.
    var state = form.__productInquiryMode;

    if (!state) {
      state = form.__productInquiryMode = {
        isCoa: false,
        title: title.textContent,
        draft: message.value,
        required: message.required,
        display: messageGroup.style.display
      };
    }

    var isCoa = trigger.getAttribute('data-inquiry-mode') === 'coa';

    if (isCoa && !state.isCoa) {
      state.draft = message.value;
    }

    title.textContent = isCoa ? 'Download COA' : state.title;

    messageGroup.hidden = isCoa;
    messageGroup.style.display = isCoa ? 'none' : state.display;

    message.required = isCoa ? false : state.required;

    if (isCoa) {
      message.value = coaMessage;
    } else if (state.isCoa) {
      message.value = state.draft;
    }

    // Clear previous feedback when switching between request types.
    if (isCoa !== state.isCoa) {
      var feedback = form.querySelector('.n8n-form-message');

      if (feedback) {
        feedback.textContent = '';
        feedback.style.display = 'none';
      }
    }

    state.isCoa = isCoa;
  }, true);

  // Ensure repeat COA submissions still include the default message,
  // even after the existing submission code resets the form.
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (
      !form.__productInquiryMode ||
      !form.__productInquiryMode.isCoa
    ) {
      return;
    }

    var message = form.querySelector(
      'textarea[name="contact[body]"]'
    );

    if (message) {
      message.value = coaMessage;
    }
  }, true);
})();